import React, { useEffect, useState, useMemo, useContext } from "react";
import Moment from 'react-moment';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
  Input,
  FormFeedback,
  Label,
  Form,
  Dropdown,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import { IntzServiceContext } from "services/intzService";
import ControlledTableContainerV8 from "components/Common/ControlledTableContainerV8";
import { getAuthTypeCssClasses } from './AppEndpointUIHelper';
import AppEndpointModal from "./AppEndpointModal";

// Column
const Id = (cell) => {
  return cell.getValue() ? "#AE" + cell.getValue() : '';
};
const Description = (cell) => {
    return cell.getValue() ? cell.getValue() : '';
};
const BaseUrl = (cell) => {
  return cell.getValue() ? cell.getValue() : '';
};
const Threshold = (cell) => {
  return cell.getValue() ? cell.getValue() : '';
};
const AuthType = (cell) => {
  return cell.getValue() ? <span className={getAuthTypeCssClasses(cell.getValue())}>{cell.getValue()}</span> : '';
};
const CreatedOn = (cell) => {
    return cell.getValue() ? <Moment format='ll'>{cell.getValue()}</Moment>: '';
};

const AppEndpointList = props => {

  //meta title
  document.title = "App Endpoints | Integratiz";
  const { intzSvc } = useContext(IntzServiceContext);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  
  const handleEntityClick = arg => {

  };

  // Customber Column
  const columns = useMemo(
    () => [

      {
        header: 'Id',
        accessorKey: 'id',
        filterable: false,
        enableSorting: true,
        cell: (cellProps) => {
          return <Id {...cellProps} />;
        }
      },
      {
        header: 'Description',
        accessorKey: 'description',
        enableSorting: true,
        filterable: false,
        cell: (cellProps) => {
          return <Description {...cellProps} />;
          ;
        }
      },
      {
        header: 'Base URL',
        accessorKey: 'baseUrl',
        enableSorting: false,
        filterable: false,
        cell: (cellProps) => {
          return <BaseUrl {...cellProps} />;
        }
      },
      {
        header: 'Threshold',
        accessorKey: 'threshold',
        enableSorting: false,
        filterable: false,
        cell: (cellProps) => {
          return <Threshold {...cellProps} />;
        }
      },
      {
        header: 'Auth Type',
        accessorKey: 'authType',
        enableSorting: false,
        filterable: false,
        cell: (cellProps) => {
          return <AuthType {...cellProps} />;
        }
      },
      {
        header: 'Created On',
        accessorKey: 'createdOn',
        enableSorting: true,
        cell: (cellProps) => {
          return <CreatedOn {...cellProps} />;
        }
      },
      {
        header: 'Action',
        enableSorting: false,
        cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" href="#" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem href="#"
                  onClick={() => {
                    const entityData = cellProps.row.original;
                    onEditClick(entityData);
                  }
                  }
                >
                  <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
                  Edit
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem>

                <DropdownItem href="#"
                  onClick={() => {
                    const entityData = cellProps.row.original;
                    onDeleteClick(entityData);
                  }}>
                  <i className="mdi mdi-trash-can font-size-16 text-danger me-1" id="deletetooltip"></i>
                  Delete
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        }
      },
    ],
    []
  );
  //delete 
  const [deleteModal, setDeleteModal] = useState(false);
  const [entityData, setEntityData] = useState({});
  const [errorMessage, setErrorMessage] = useState();
  const [appId, setAppId] = useState();
  const [rerender, setRerender] = useState(0);
  const [appList, setAppList] = useState([]);
  const onDeleteClick = (entityData) => {
    setEntityData(entityData);
    setErrorMessage("");
    setDeleteModal(true);
  };

  const handleDeleteEntity = () => {
    if (entityData && entityData.id) {
      intzSvc.deleteAppEndpoint(entityData.id).then(({data}) => {
        setDeleteModal(false);
        setRerender(rerender + 1);
      }).catch(err => {
        setErrorMessage(err.response.data);
      });
    }
  };

  const onEditClick = (entityData) => {
    setEntityData(entityData);
    setErrorMessage("");
    setIsEdit(true);
    setModal(true);
  };
  const onAddClick = () => {
    setEntityData({});
    setErrorMessage("");
    setIsEdit(false);
    setModal(true);
  };
  const handleModalClose = (isUpdated) => {
      if(isUpdated) {
        setRerender(rerender + 1);
      }
      setModal(false);
    
  };
  useEffect(() => {
    intzSvc.searchApp(100,0,'createdOn','desc').then(({data}) => {
      setAppList(data.value);
    }).finally(() => {
    });
  }, []);
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEntity}
        onCloseClick={() => setDeleteModal(false)}
        entityName={"endpoint"}
        errorMessage={errorMessage}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="App Endpoint" breadcrumbItem="List" 
          altTitle={"LIST : "} button={
            <select
            className="form-select form-select-sm mt-1"
            value={appId}
            onChange={(e) => {
              setAppId(e.target.value);
              setRerender(rerender +  1);
            }}>
            <option key={''} value={''}>
            All Apps
              </option>
            {appList.map(app => (
              <option key={app.id} value={app.id}>
                {app.description}
              </option>
            ))}
          </select>
          } />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <ControlledTableContainerV8
                    columns={columns}
                    odataFetch={intzSvc.searchAppEndpoint}
                    initialSortBy={"createdOn"}
                    isGlobalFilter={true}
                    fetchCondition={appId ? "appId eq "+ appId : ""}
                    addButtonLabel={"Endpoint"}
                    onAddClick={onAddClick}
                    customPageSize={10}
                    rerender={rerender}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <AppEndpointModal
                show={modal}
                isEdit={isEdit}
                id={entityData?.id}
                onClose={handleModalClose}
                errorMessage={errorMessage}
      />
    </React.Fragment>
  );
};

export default AppEndpointList;